import { __rest } from "tslib";
import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
import { Input } from '../input/input.component';
export var TextInput = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return React.createElement(Input, Object.assign({}, props, {
    className: ClassNames.concat('arm-text-input', className),
    ref: ref,
    type: "text"
  }));
} // type assertion to ensure generic works with RefForwarded component
// DO NOT CHANGE TYPE WITHOUT CHANGING THIS, FIND TYPE BY INSPECTING React.forwardRef
);